export const SET_PROFIT_OVERVIEW_V2_STATE = 'SET_PROFIT_OVERVIEW_V2_STATE'
